<template>
    <div class="kyc-checkbox-section">
        <div class="col-form-label">
            <div class="form-group">
                <div class="custom-control custom-checkbox w-100">
                    <input
                        id="reviewRole"
                        v-model="parentCheck"
                        class="custom-control-input"
                        type="checkbox"
                        @click="uncheckAll"
                    />
                    <label class="custom-control-label" for="reviewRole"
                        ><span>{{ parentName }}</span></label
                    >
                </div>

                <b-form-radio-group
                    :id="radioName"
                    v-model="selected"
                    class="ml-4 add-role-radio"
                    :options="radioListing"
                    name="review"
                ></b-form-radio-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        radioListing: {
            type: Array,
            default: null,
        },

        parentName: {
            type: String,
            default: null,
        },
        indeterminate: {
            type: Boolean,
        },
        radioName: {
            type: String,
            default: '',
        },
        selectedValue: {
            type: String,
            default: '',
        },
    }, // End of Component > props

    data() {
        return {
            parentCheck: this.checkParent(),
            selected: this.setValue(),
            allSelected: false,
            previous: null,
        }
    },
    watch: {
        selected(value) {
            if (value) {
                this.parentCheck = true
            }
            this.$emit('get-selected', value, this.parentName, '', 'radio')
        },
    },
    methods: {
        setValue() {
            if (this.selectedValue) {
                return this.selectedValue
            }
            return null
        },

        uncheck: function (val) {
            if (val == this.previous) {
                this.selected = false
            }
            this.previous = this.selected
        },

        uncheckAll: function () {
            if (!this.parentCheck) {
                this.parentCheck = true
            } else {
                this.parentCheck = false
                this.selected = false
            }
        },
        checkParent() {
            if (this.selectedValue) {
                return true
            }
            return false
        },
    },
}
</script>
